var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProcesimg12(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 16,
    viewBox: "0 0 22 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14.5917 13.0332H19C20.1046 13.0332 21 12.0453 21 10.8266V4.57043C21 3.73462 20.572 2.97054 19.8944 2.59675L17.8446 1.46592C17.2892 1.15952 16.6767 1 16.0557 1H13.9225C12.7074 1 11.5581 1.60943 10.799 2.65633L10.7739 2.69096M10.7739 2.69096L8.83452 5.36569C8.35943 6.02092 8.40684 6.9655 8.94461 7.55884C9.52749 8.20194 10.4725 8.20194 11.0554 7.55884L12.4706 5.99741L14.7615 10.6313C15.3882 11.8991 14.7606 13.4784 13.4907 13.8287L9.9609 14.8023C8.68876 15.1532 7.34745 15.0347 6.14217 14.4647L2.21216 12.6064C1.47679 12.2587 1 11.4609 1 10.5782V4.57043C1 3.73462 1.428 2.97054 2.10557 2.59675L4.15542 1.46592C4.71084 1.15952 5.32329 1 5.94427 1H7.62547C8.86642 1 10.0234 1.63403 10.7739 2.69096Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProcesimg12);
export default __webpack_public_path__ + "static/media/procesimg12.e97d17970e84eae3ede01cf02fb42314.svg";
export { ForwardRef as ReactComponent };